var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(_vm.currentTabComponent,{tag:"component",on:{"close":function($event){return _vm.$emit('close')},"toggleTab":function($event){return _vm.toggleTab($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }